// Razorpay utility functions
export const initializeRazorpay = () => {
  return new Promise((resolve) => {
    // Check if Razorpay is already loaded
    if (window.Razorpay) {
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      console.error('Failed to load Razorpay script');
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

export const createRazorpayOrder = async (amount, currency = 'INR', receipt = '') => {
  try {
    console.log('Creating Razorpay order with:', { amount, currency, receipt });
    
    const response = await fetch('/api/create-razorpay-order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount: amount * 100, // Razorpay expects amount in paise
        currency,
        receipt: receipt || `receipt_${Date.now()}`,
      }),
    });

    console.log('Response status:', response.status);
    const data = await response.json();
    console.log('Response data:', data);
    
    if (!response.ok) {
      throw new Error(data.error || data.message || 'Failed to create order');
    }

    return data;
  } catch (error) {
    console.error('Error creating Razorpay order:', error);
    throw error;
  }
};

export const processRazorpayPayment = async (orderData, productDetails, onSuccess, onFailure) => {
  try {
    console.log('Processing Razorpay payment with:', { orderData, productDetails });
    
    // Get the Razorpay key from environment variables
    const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY_ID;
    
    if (!razorpayKey) {
      throw new Error('Razorpay key not configured');
    }
    
    const options = {
      key: razorpayKey,
      amount: orderData.amount,
      currency: orderData.currency,
      name: 'Pingfence',
      description: productDetails.name || 'Digital Product',
      order_id: orderData.id,
      handler: function (response) {
        console.log('Payment successful:', response);
        // Payment successful
        onSuccess(response);
      },
      prefill: {
        name: 'Customer Name',
        email: 'customer@example.com',
        contact: '9999999999'
      },
      notes: {
        product_id: productDetails.id,
        product_name: productDetails.name,
        product_category: productDetails.category
      },
      theme: {
        color: '#9FE240'
      },
      modal: {
        ondismiss: function() {
          console.log('Payment modal dismissed');
          onFailure('Payment cancelled by user');
        }
      }
    };

    console.log('Creating Razorpay instance with options:', options);
    
    if (!window.Razorpay) {
      throw new Error('Razorpay not loaded');
    }
    
    const rzp = new window.Razorpay(options);
    console.log('Razorpay instance created, opening modal...');
    rzp.open();
  } catch (error) {
    console.error('Error processing Razorpay payment:', error);
    onFailure(error.message || 'Failed to process payment');
  }
};

export const verifyRazorpayPayment = async (paymentId, orderId, signature) => {
  try {
    const response = await fetch('/api/verify-razorpay-payment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        paymentId,
        orderId,
        signature,
      }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Payment verification failed');
    }

    return data;
  } catch (error) {
    console.error('Error verifying Razorpay payment:', error);
    throw error;
  }
};
